module.exports = __webpack_public_path__ + "img/a111.ae3c1828.png";